// src/dashboard/components/SortIndicator.js

import React from 'react';

const SortIndicator = ({ column, sortConfig }) => {
    if (sortConfig.by !== column) return null;
    return <span style={{ marginLeft: '4px' }}>{sortConfig.order === 'asc' ? '▲' : '▼'}</span>;
};

export default SortIndicator;